import { resolvePatientProfileUrl } from './assetUrls';

/**
 * Patient profile images are served from the API origin; a path-only URL breaks on the CRA dev host.
 * @param {string|null|undefined} raw - Filename, relative path, or absolute URL from API
 * @returns {string|null}
 */
export function buildPatientProfileImageUrl(raw) {
  return resolvePatientProfileUrl(raw);
}
